module.exports = __webpack_public_path__ + "media/stylesheets/images/landsnet_logo-af8b5ad3316c5501f74aecd37c9ad82c.gif";